module.exports = "/assets/images/right-arrow_0132d0.svg";